AuthRoute = require 'mixins/authenticated-route'

App.SettingsSipRoute = Em.Route.extend AuthRoute,
  session: Em.inject.service()
  env:     Em.inject.service('environment')

  model: ->
    organization_id = @get('session').get('currentOrganization.id')

    @store.find('staff_member', { organization_id: organization_id })
      .then (staff) =>
        staff.filter (s) -> s.get('sip_enabled', true)
